module.exports = __webpack_public_path__ + "static/media/team_6.79867f3b.png";